// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var MM_wrk_ctx = require("./MM_wrk_ctx.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var MM_proof_tree_dto = require("../mm-utils/MM_proof_tree_dto.bs.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");

var procName = "MM_wrk_unify";

function unify(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, stmts, bottomUpProverParams, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx.beginWorkerInteractionUsingCtx(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, procName, /* Unify */{
                    stmts: stmts,
                    bottomUpProverParams: bottomUpProverParams
                  }, (function (resp, sendToWorker, endWorkerInteraction) {
                      if (resp.TAG === /* OnProgress */0) {
                        return Curry._1(onProgress, resp._0);
                      }
                      Curry._1(endWorkerInteraction, undefined);
                      Curry._1(resolve, resp._0);
                    }), false, undefined);
            });
}

function processOnWorkerSide(req, sendToClient) {
  var stmts = req.stmts;
  var proofTree = MM_provers.unifyAll(MM_wrk_ctx.getWrkCtxExn(undefined), MM_wrk_ctx.getWrkFrmsExn(undefined), stmts, MM_wrk_ctx.getWrkParenCntExn(undefined), req.bottomUpProverParams, (function (msg) {
          Curry._1(sendToClient, {
                TAG: /* OnProgress */0,
                _0: msg
              });
        }), undefined);
  Curry._1(sendToClient, {
        TAG: /* Result */1,
        _0: MM_proof_tree_dto.proofTreeToDto(proofTree, stmts.map(function (stmt) {
                  return stmt.expr;
                }))
      });
}

function doesntHaveBackRefs(newStmtsDto) {
  var res = newStmtsDto.stmts.reduce((function (res, stmt) {
          if (res.TAG !== /* Ok */0) {
            return res;
          }
          var refs = res._0;
          var jstf = stmt.jstf;
          if (jstf !== undefined) {
            jstf.args.forEach(function (ref) {
                  refs.push(ref);
                });
          }
          if (refs.includes(stmt.label)) {
            return {
                    TAG: /* Error */1,
                    _0: undefined
                  };
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: refs
                  };
          }
        }), {
        TAG: /* Ok */0,
        _0: []
      });
  if (res.TAG === /* Ok */0) {
    return true;
  } else {
    return false;
  }
}

function proofTreeDtoToNewStmtsDto(treeDto, rootStmts, ctx, typeToPrefix) {
  var newVarTypes = Belt_HashMapInt.fromArray(treeDto.newVars.map(function (param) {
            if (param.length !== 2) {
              throw {
                    RE_EXN_ID: "Match_failure",
                    _1: [
                      "MM_wrk_unify.res",
                      269,
                      53
                    ],
                    Error: new Error()
                  };
            }
            var typ = param[0];
            var $$var = param[1];
            return [
                    $$var,
                    typ
                  ];
          }));
  var stmtToProve = Caml_array.get(rootStmts, rootStmts.length - 1 | 0);
  var node = treeDto.nodes.find(function (node) {
        return MM_context.exprEq(node.expr, stmtToProve.expr);
      });
  var proofNode;
  if (node !== undefined) {
    proofNode = node;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "the proof tree DTO doesn't contain the node to prove."
          },
          Error: new Error()
        };
  }
  var parents = proofNode.parents;
  if (parents !== undefined) {
    return parents.map(function (src) {
                      if (typeof src === "number") {
                        return ;
                      }
                      if (src.TAG === /* Hypothesis */0) {
                        return ;
                      }
                      var args = src.args;
                      var maxCtxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
                      var res_newVars = [];
                      var res_newVarTypes = [];
                      var res_newDisj = MM_context.disjMutableMake(undefined);
                      var res_newDisjStr = [];
                      var res_stmts = [];
                      var res = {
                        newVars: res_newVars,
                        newVarTypes: res_newVarTypes,
                        newDisj: res_newDisj,
                        newDisjStr: res_newDisjStr,
                        stmts: res_stmts
                      };
                      var exprToLabel = Belt_HashMap.fromArray(rootStmts.map(function (stmt) {
                                return [
                                        stmt.expr,
                                        stmt.label
                                      ];
                              }), MM_context.ExprHash);
                      var varNames = Belt_HashMapInt.make(8);
                      var usedVarNames = Belt_HashSetString.make(8);
                      var usedLabels = Belt_HashSetString.fromArray(rootStmts.map(function (stmt) {
                                return stmt.label;
                              }));
                      var getFrame = function (label) {
                        var frame = MM_context.getFrame(ctx, label);
                        if (frame !== undefined) {
                          return frame;
                        }
                        throw {
                              RE_EXN_ID: MM_parser.MmException,
                              _1: {
                                msg: "Cannot get a frame by label '" + label + " in srcToNewStmts.'"
                              },
                              Error: new Error()
                            };
                      };
                      var intToSym = function (i) {
                        if (i <= maxCtxVar) {
                          var sym = MM_context.ctxIntToSym(ctx, i);
                          if (sym !== undefined) {
                            return sym;
                          }
                          throw {
                                RE_EXN_ID: MM_parser.MmException,
                                _1: {
                                  msg: "Cannot determine sym for an existing int in nodeToNewStmts."
                                },
                                Error: new Error()
                              };
                        }
                        var name = Belt_HashMapInt.get(varNames, i);
                        if (name !== undefined) {
                          return name;
                        }
                        throw {
                              RE_EXN_ID: MM_parser.MmException,
                              _1: {
                                msg: "Cannot determine name of a new var in nodeToNewStmts."
                              },
                              Error: new Error()
                            };
                      };
                      var addExprToResult = function (label, expr, jstf, isProved) {
                        expr.forEach(function (ei) {
                              if (!(ei > maxCtxVar && !res_newVars.includes(ei))) {
                                return ;
                              }
                              var typ = Belt_HashMapInt.get(newVarTypes, ei);
                              if (typ !== undefined) {
                                res_newVars.push(ei);
                                res_newVarTypes.push(typ);
                                var newVarName = Caml_array.get(MM_context.generateNewVarNames(ctx, [typ], typeToPrefix, Caml_option.some(usedVarNames), undefined), 0);
                                Belt_HashSetString.add(usedVarNames, newVarName);
                                return Belt_HashMapInt.set(varNames, ei, newVarName);
                              }
                              throw {
                                    RE_EXN_ID: MM_parser.MmException,
                                    _1: {
                                      msg: "Cannot determine type of a new var in nodeToNewStmts."
                                    },
                                    Error: new Error()
                                  };
                            });
                        var exprStr = expr.map(intToSym).join(" ");
                        var jstf$1;
                        if (jstf !== undefined && !(typeof jstf === "number" || jstf.TAG === /* Hypothesis */0)) {
                          var label$1 = jstf.label;
                          var args = jstf.args;
                          var argLabels = [];
                          getFrame(label$1).hyps.forEach(function (hyp, i) {
                                if (hyp.typ !== /* E */1) {
                                  return ;
                                }
                                var argLabel = Belt_HashMap.get(exprToLabel, Caml_array.get(treeDto.nodes, Caml_array.get(args, i)).expr);
                                if (argLabel !== undefined) {
                                  argLabels.push(argLabel);
                                  return ;
                                }
                                throw {
                                      RE_EXN_ID: MM_parser.MmException,
                                      _1: {
                                        msg: "Cannot get a label for an arg by arg's expr."
                                      },
                                      Error: new Error()
                                    };
                              });
                          jstf$1 = {
                            args: argLabels,
                            label: label$1
                          };
                        } else {
                          jstf$1 = undefined;
                        }
                        res_stmts.push({
                              label: label,
                              expr: expr,
                              exprStr: exprStr,
                              jstf: jstf$1,
                              isProved: isProved
                            });
                      };
                      var frame = getFrame(src.label);
                      var eArgs = [];
                      frame.hyps.forEach(function (hyp, i) {
                            if (hyp.typ === /* E */1) {
                              eArgs.push(Caml_array.get(treeDto.nodes, Caml_array.get(args, i)));
                              return ;
                            }
                            
                          });
                      eArgs.forEach(function (node) {
                            Expln_utils_data.traverseTree(undefined, node, (function (param, node) {
                                    if (Belt_HashMap.has(exprToLabel, node.expr)) {
                                      return ;
                                    }
                                    var match = node.proof;
                                    if (match === undefined) {
                                      return ;
                                    }
                                    if (typeof match === "number") {
                                      return ;
                                    }
                                    if (match.TAG === /* Hypothesis */0) {
                                      return ;
                                    }
                                    var args = match.args;
                                    var children = [];
                                    getFrame(match.label).hyps.forEach(function (hyp, i) {
                                          if (hyp.typ !== /* E */1) {
                                            return ;
                                          }
                                          var argNode = Caml_array.get(treeDto.nodes, Caml_array.get(args, i));
                                          if (!Belt_HashMap.has(exprToLabel, argNode.expr)) {
                                            children.push(argNode);
                                            return ;
                                          }
                                          
                                        });
                                    return children;
                                  }), undefined, undefined, (function (param, node) {
                                    if (!Belt_HashMap.has(exprToLabel, node.expr)) {
                                      var newLabel = Caml_array.get(MM_context.generateNewLabels(ctx, "", 1, Caml_option.some(usedLabels), undefined), 0);
                                      Belt_HashMap.set(exprToLabel, node.expr, newLabel);
                                      Belt_HashSetString.add(usedLabels, newLabel);
                                      addExprToResult(newLabel, node.expr, node.proof, Belt_Option.isSome(node.proof));
                                    }
                                    
                                  }), undefined);
                          });
                      var stmtToProve = Caml_array.get(rootStmts, rootStmts.length - 1 | 0);
                      addExprToResult(stmtToProve.label, stmtToProve.expr, src, args.every(function (idx) {
                                return Belt_Option.isSome(Caml_array.get(treeDto.nodes, idx).proof);
                              }));
                      var varIsUsed = function (v) {
                        if (v <= maxCtxVar) {
                          return true;
                        } else {
                          return res_newVars.includes(v);
                        }
                      };
                      MM_context.disjForEach(treeDto.disj, (function (n, m) {
                              if (varIsUsed(n) && varIsUsed(m) && !MM_context.isDisj(ctx, n, m)) {
                                MM_context.disjAddPair(res_newDisj, n, m);
                                res_newDisjStr.push("$d " + intToSym(n) + " " + intToSym(m) + " $.");
                                return ;
                              }
                              
                            }));
                      return res;
                    }).filter(Belt_Option.isSome).map(Belt_Option.getExn).filter(doesntHaveBackRefs);
  } else {
    return [];
  }
}

exports.procName = procName;
exports.unify = unify;
exports.processOnWorkerSide = processOnWorkerSide;
exports.proofTreeDtoToNewStmtsDto = proofTreeDtoToNewStmtsDto;
/* MM_context Not a pure module */
